import { Chip, Paper, Stack, Table, TableBody, TableHead, TableRow, Typography } from '@mui/material';

import {
  GeneralTableBox,
  HeadTableCell,
  PaginationTable,
  RowTableCell,
} from '../../../../common/components';
import {
  formatInstallments,
  formatInteger,
  formatPuntajePoints,
} from '../../utils/puntajeFormatters';
import TableStateRow from '../common/TableStateRow';

const DashboardGroupsTable = ({
  dashboardRows,
  selectedGroupUuid,
  onSelectGroup,
  isLoading,
  pagination,
}) => (
  <Paper elevation={0} sx={{ p: 2.5, borderRadius: 0 }}>
    <Typography variant="h6" sx={{ mb: 2 }}>
      Dashboard por grupo
    </Typography>
    <GeneralTableBox>
      <Table>
        <TableHead>
          <TableRow>
            <HeadTableCell>Grupo</HeadTableCell>
            <HeadTableCell>Cuotas</HeadTableCell>
            <HeadTableCell>Puntaje</HeadTableCell>
            <HeadTableCell>Sorteo</HeadTableCell>
            <HeadTableCell>Elegibles base</HeadTableCell>
            <HeadTableCell>Adjudicables</HeadTableCell>
            <HeadTableCell>Morosos</HeadTableCell>
            <HeadTableCell>Top ranking</HeadTableCell>
            <HeadTableCell>Sugerencias</HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!dashboardRows.length ? (
            <TableStateRow
              colSpan={9}
              loading={isLoading}
              emptyMessage="No hay informacion del dashboard para el periodo."
            />
          ) : (
            dashboardRows.map((row) => (
              <TableRow
                key={row.uuid_group}
                hover
                selected={row.uuid_group === selectedGroupUuid}
                onClick={() => onSelectGroup(row.uuid_group)}
                sx={{ cursor: 'pointer' }}
              >
                <RowTableCell>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography>{row.group_name}</Typography>
                    {row.uuid_group === selectedGroupUuid ? (
                      <Chip label="Seleccionado" size="small" color="primary" variant="outlined" />
                    ) : null}
                  </Stack>
                </RowTableCell>
                <RowTableCell>{formatInstallments(row.puntaje_balance_installments)}</RowTableCell>
                <RowTableCell>{formatPuntajePoints(row.puntaje_balance_installments)}</RowTableCell>
                <RowTableCell>{formatInstallments(row.sorteo_balance_installments)}</RowTableCell>
                <RowTableCell>{formatInteger(row.total_base_eligible_contracts)}</RowTableCell>
                <RowTableCell>{formatInteger(row.total_award_eligible_contracts)}</RowTableCell>
                <RowTableCell>{formatInteger(row.total_morose_contracts)}</RowTableCell>
                <RowTableCell>
                  {row.top_contract_number || '-'}
                  {row.top_score_installments
                    ? ` (${formatInstallments(row.top_score_installments)} cuotas | ${formatPuntajePoints(row.top_score_installments)} puntos)`
                    : ''}
                </RowTableCell>
                <RowTableCell>
                  <Stack direction="row" spacing={0.5} flexWrap="wrap">
                    {row.puntaje_suggestion ? (
                      <Chip label="Puntaje" size="small" color="success" />
                    ) : null}
                    {row.sorteo_suggestion ? (
                      <Chip label="Sorteo" size="small" color="warning" />
                    ) : null}
                    {row.desborde_suggestion ? (
                      <Chip label="Desborde" size="small" color="info" />
                    ) : null}
                    {!row.puntaje_suggestion && !row.sorteo_suggestion && !row.desborde_suggestion
                      ? '-'
                      : null}
                  </Stack>
                </RowTableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
    {!!pagination?.totalCount && (
      <PaginationTable
        page={pagination.page}
        totalPages={pagination.totalPages}
        totalCount={pagination.totalCount}
        rowsPerPage={pagination.rowsPerPage}
        onPageChange={pagination.handlePageChange}
        onRowsPerPageChange={pagination.handleRowsPerPageChange}
      />
    )}
  </Paper>
);

export default DashboardGroupsTable;
